<template>
  <div class="gmf-comment-section gmf-context" :class="'gmf-comment-section--' + commentType">

    <div class="gmf-comment-section-product-header" v-if="showProductInfo && product">
      <img :src="product.imageUrl" />
      <div>
        <div class="gmf-subheader">{{ product.name }}</div>
        <Link v-if="product.url" :href="product.url" class="gmf-link">{{ t('visit_product') }}</Link>
      </div>
    </div>

    <nav class="gmf-comment-section-nav">
      <button class="gmf-comment-section-nav-link" v-if="availableCommentTypes.includes('product_review')"
        :class="{ 'gmf-active': commentType == 'product_review' }"
        @click="commentType = 'product_review'">{{ t('tab_text.product_review') }} ({{ commentCounts.product_review || 0
        }})</button>
      <button class="gmf-comment-section-nav-link" v-if="availableCommentTypes.includes('product_question')"
        :class="{ 'gmf-active': commentType == 'product_question' }"
        @click="commentType = 'product_question'">{{ t('tab_text.product_question') }} ({{ commentCounts.product_question
        || 0 }})</button>
      <button class="gmf-comment-section-nav-link" v-if="availableCommentTypes.includes('product_hype')"
        :class="{ 'gmf-active': commentType == 'product_hype' }"
        @click="commentType = 'product_hype'">{{ t('tab_text.product_hype') }} ({{ commentCounts.product_hype || 0 }})</button>
      <button class="gmf-comment-section-nav-link" v-if="availableCommentTypes.includes('product_discussion')"
        :class="{ 'gmf-active': commentType == 'product_discussion' }"
        @click="commentType = 'product_discussion'">{{ t('tab_text.product_discussion') }} ({{
          commentCounts.product_discussion || 0 }})</button>
    </nav>

    <div class="gmf-comment-section-body">

      <RatingSummarySection v-if="ratingSummaries" :commentType="commentType" :ratingSummaries="ratingSummaries">
        <CommentForm v-if="showFormInSummaryBlock && canComment" :commentType="commentType" :targetId="targetId"
          :variants="product && product.variants && product.variants.length > 1 ? product.variants : null" />
      </RatingSummarySection>

      <ReviewSummary :productId="targetId" :hideStars="true" v-if="showReviewSummary" />

      <div class="gmf-comment-section-body-content">
        <div v-if="ingress" class="gmf-md gmf-mb-3" v-html="ingress" />

        <CommentForm v-if="!showFormInSummaryBlock && canComment" :commentType="commentType" :targetId="targetId"
          :variants="product && product.variants && product.variants.length > 1 ? product.variants : null" />

        <DropdownSelect class="gmf-mb-4" v-if="commentCounts[commentType] > 0 && sortingMethodOptions.length > 1" v-model="sortingMethod"
          :options="sortingMethodOptions" />
        <Comment v-for="comment in displayedComments" :key="comment.id" :comment="comment" :depth="0"
          :voteMode="state.merchantConfig.voteMode" :targetId="targetId" :expandReplies="true"
          @loadReplies="loadReplies" />
        <div class="gmf-loading" v-if="isLoading"></div>

        <div class="gmf-btn gmf-btn-primary gmf-btn-sm gmf-show-more-comments" v-if="remainingComments > 0"
          @click="loadPage">{{ t('show_more_comments') }} ({{ remainingComments }})</div>

        <a v-if="showGamifieraText" class="gmf-from-us" href="https://gamifiera.com" target="_blank">{{ fromUsText }}</a>
      </div>
    </div>
    <LdJson v-if="state.merchantConfig.structuredDataType == 'json-ld'" :comments="comments"
      :ratingSummaries="ratingSummaries" :product="product" />

  </div>
</template>

<style>
.gmf-comment-section-product-header {
  display: flex;
  align-items: center;
  gap: var(--gmf-p-4);
  margin-bottom: var(--gmf-p-4);
  margin-right: 20px;
}

.gmf-comment-section-product-header img {
  height: 50px;
}

.gmf-md {
  white-space: pre-wrap;
}

.gmf-loading {
  margin: 16px;
  height: 80px;
  background-image: url(https://cdn.gamifiera.com/static/icons/loading_simple.svg);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.gmf-comment-section {
  color: var(--gmf-col-black);
}


.gmf-select {
  border: 1px solid var(--gmf-col-darkgray);
  border-radius: var(--gmf-rounding);
  padding: 6px 12px;
  background-color: white;
  margin-bottom: 16px;
}



.gmf-comment-section-nav {
  border-bottom: 1px solid var(--gmf-col-darkgray);
  padding-bottom: 4px;
  margin-bottom: 24px;
}

.gmf-context .gmf-comment-section-nav-link {
  padding: 12px 18px;
  display: inline-block;
  color: #111;
  font-size: 14px;
  cursor: pointer;
  color: var(--gmf-col-nearblack);
  text-decoration: none;

  /* Button reset */
  border: none;
  margin: none;
  background: none;
}

.gmf-context .gmf-comment-section-nav-link:hover {
  text-decoration: none;
  background-color: var(--gmf-col-lightgray);
  color: var(--gmf-col-black);
}

.gmf-comment-section-nav-link.gmf-active {
  border-bottom: 3px solid var(--gmf-col-nearblack);
  color: var(--gmf-col-black);
}

.gmf-show-more-comments {
  margin-top: 16px;
  margin-bottom: 16px;
  text-align: center;
}

.gmf-comment-section .gmf-dropdown {
  display: inline-block;
  width: auto;
  margin-bottom: var(--gmf-p-4);
}

.gmf-comment-section-body {
  display: flex;
  flex-direction: column;
  position: relative;
  gap: var(--gmf-p-5);
}

.gmf-comment-section-body-content .gmf-comment-form {
  margin-bottom: 32px;
}

.gmf-comment-section-body-content .gmf-comment-form-login-invite {
  margin-bottom: 24px;
}

@media (max-width: 480px) {
  .gmf-comment-footer-btn {
    font-size: 13px;
  }
}

.gmf-from-us {
  filter: initial;
  align-self: center;
  opacity: 0.3;
  flex-shrink: 0;
  font-weight: 600 !important;
  text-decoration: none !important;
  color: var(--gmf-col-darkgray) !important;
  font-size: var(--gmf-text-small-font-size) !important;
  display: block;
  margin-top: 8px;
  margin-bottom: 16px;
}
</style>

<script>
import state from '@/state';
import callApi from '@/utils/callApi';
import LdJson from './LdJson';
import { memoize } from '@gamifiera/array-cache';
import DropdownSelect from '@/components/DropdownSelect';

import Comment from '@/components/Comment';
import CommentForm from '@/components/CommentForm';
import Link from '@/components/Link';
import getProductRatings from '@/utils/getProductRatings';

import RatingSummarySection from './RatingSummarySection';
import md from '@/utils/md';
import ReviewSummary from '@/widgets/ReviewSummary';

const t = state.t.prefix('comments');

function getIdMap(comments, idMap = {}) {
  for (const comment of comments) {
    idMap[comment.id] = comment;
    if (comment.replies) {
      getIdMap(comment.replies, idMap);
    }
  }
  return idMap;
}

const getProductInfo = memoize(async function (productId) {
  const res = await callApi('GET', '/v1/client/comment-product-info/' + productId);
  const product = await res.json();

  product.id = productId; // @TODO add to backend?

  return product;
}, 300);

export default {
  name: 'CommentSection',
  components: {
    Link,
    Comment,
    CommentForm,
    LdJson,
    DropdownSelect,
    RatingSummarySection,
    ReviewSummary,
  },
  props: ['targetId', 'showProductInfo', 'commentTypes', 'mockJson'],
  data() {
    let sortMethod = 'votes';
    if (state.merchantConfig.widgets?.comments?.useBestSort) {
      sortMethod = 'best';
    } else if (state.merchantConfig.voteMode === 'disabled') {
      sortMethod = 'created';
    }
    return {
      state,

      isLoading: false,

      comments: [],
      ratingSummaries: null,

      commentCounts: {},

      commentType: 'product_review',

      sortingMethod: sortMethod,

      page: 1,

      product: null,
    };
  },
  computed: {
    canComment() {
      // @TODO could be false before product info is loaded perhaps, to prevent flickering
      if (this.commentType === 'product_review') {
        return !this.product?.isNotReviewable;
      }
      return true;
    },
    showReviewSummary() {
      if (this.commentType !== 'product_review') {
        return false;
      }
      const mc = this.state.merchantConfig;
      if (! mc.widgets?.commentSection?.aiSummary?.enabled) {
        return false;
      }
      return mc.comments?.product_review?.aiSummaries?.enabled || false;
    },
    showFormInSummaryBlock() {
      return this.state.merchantConfig.widgets?.comments?.reviewFormInSummaryBlock;
    },
    commentTypeFilter() {
      return this.commentTypes ? this.commentTypes.split(',').map(s => s.trim()) : null;
    },
    sortingMethodOptions() {
      const options = [];
      if (state.merchantConfig.voteMode !== 'disabled') {
        options.push({
          value: 'votes',
          label: t('most_likes'),
        })
      }
      options.push({
        value: 'created',
        label: t('latest'),
      });
      if (state.merchantConfig?.widgets?.comments?.useBestSort) {
        options.unshift({
          value: 'best',
          label: t('best'),
        });
      }
      return options;
    },
    mockData() {
      if (!this.mockJson) {
        return null;
      }
      try {
        return JSON.parse(this.mockJson);
      } catch (e) {
        console.error('Failed to parse mockJson', e);
        return null;
      }
    },
    displayedComments() {
      return this.mockData?.length > 0 ? this.mockData : this.comments;
    },
    ingress() {
      const t = state.t('comments.form_ingress.' + this.commentType);
      if (!t) {
        return null;
      }
      return md(t);
    },
    availableCommentTypes() {
      if (!this.state.merchantConfig.comments) {
        return [];
      }

      const types = ['product_review', 'product_question', 'product_discussion'].filter(f => this.state.merchantConfig.comments[f].enabled);

      if (this.commentTypeFilter && this.commentTypeFilter.length > 0) {
        return types.filter(t => this.commentTypeFilter.includes(t));
      }

      return types;
      /*
      const types = [];
      if (this.product) {
        if (this.product.isReleased) {
          types.push('product_review');
          types.push('product_question');
          if (this.commentCounts.product_hype > 0) {
            if (this.commentCounts.product_review > 0) {
              types.push('product_hype');
            } else {
              types.unshift('product_hype');
            }
          }
        } else {
          types.push('product_hype');
          types.push('product_question');
          if (this.commentCounts.product_review > 0) {
            types.push('product_review');
          }
        }
      }


      return types;
      */
    },
    remainingComments() {
      return (this.commentCounts[this.commentType] - this.comments.length) || 0;
    },
    query() {
      return {
        'product_id:group': this.targetId,
        'order': this.sortingMethod,
        'type': this.commentType,
        'link': 'product_review',
      };
    },
    idMap() {
      return getIdMap(this.comments);
    },
    translationsEnabled() {
      return this.state.merchantConfig?.widgets?.translations.mode !== 'translateNothing';
    },
    fromUsText() {
      return "Powered by GAMIFIERA.®";
    },
    showGamifieraText () {
      return state.merchantConfig?.widgets?.showGamifieraText;
    }
  },
  mounted() {
    if (this.targetId) {
      this.init();
    }
  },
  methods: {
    async loadProductRatings() {
      const ratings = await getProductRatings(this.targetId);
      this.ratingSummaries = ratings?.ratings;
    },
    async init() {
      this.comments = [];
      this.page = 1;

      this.loadProductRatings();

      getProductInfo(this.targetId)
        .then(product => {
          this.product = product;
          if (this.commentType !== this.availableCommentTypes[0]) {
            this.commentType = this.availableCommentTypes[0];
          } else {
            this.loadPage();
          }
        });

      const countsQuery = Object.assign({}, this.query);
      delete countsQuery.type;
      callApi('GET', '/v3/comments/counts?' + new URLSearchParams(countsQuery).toString())
        .then(res => {
          if (res.status == 401) {
            console.error('Gamifiera client not authorized');
            return;
          }
          res.json().then(data => {
            this.commentCounts = data.counts;
          });
        });
    },
    async loadPage() {
      // @TODO rating summaries
      if (! this.targetId) {
        return;
      }

      if (this.isLoading) {
        return;
      }
      const queryAtStart = JSON.stringify(this.query);
      this.isLoading = true;
      const itemsPerPage = this.state.merchantConfig.widgets?.commentSection?.itemsPerPage || 5;
      try {
        const query = Object.assign({}, this.query, {
          'skip': this.comments.length,
          'take': itemsPerPage,
          'reply_count': 2,
          'reply_depth': 2,
          'no_count': 1,
        });

        if (this.translationsEnabled) {
          query['translate'] = true;
        }

        const res = await callApi('GET', this.state.commentSearchEndpoint + '?' + new URLSearchParams(query).toString());

        if (queryAtStart != JSON.stringify(this.query)) {
          // Query has changed, throw result away
          this.isLoading = false;
          return;
        }

        const data = await res.json();

        this.comments.push(...data.comments.filter(c => !(c.id in this.idMap)));

        this.page++;
      } catch (e) {
        console.error('Error loading page!', e);
      }
      this.isLoading = false;
    },
    async loadReplies(id) {
      if (this.isLoading) {
        return;
      }
      const queryAtStart = JSON.stringify(this.query);
      this.isLoading = true;

      const root = this.idMap[id];
      if (!root) {
        console.error('Failed to load replies: Parent comment not in view');
        return;
      }

      try {
        let skip = root.replies.length;
        if (skip && root.replies[0].replyCount === null) {
          skip = 0; // need to reload the replies
        }
        const query = Object.assign({}, this.query, {
          'skip': skip,
          'take': 5,
          'reply_count': 2,
          'reply_depth': 1,
          'root': root.id,
          'translate': this.translationsEnabled,
          'include': this.include,
        });
        const res = await callApi('GET', this.state.commentSearchEndpoint + '?' + new URLSearchParams(query).toString());

        if (queryAtStart != JSON.stringify(this.query)) {
          // Query has changed, throw result away
          this.isLoading = false;
          return;
        }

        const data = await res.json();

        for (const c of data.comments) {
          if (!(c.id in this.idMap)) {
            root.replies.push(c);
          } else {
            // Update existing comment, because it might have been a partial load
            Object.assign(this.idMap[c.id], c);
          }
        }
      } catch (e) {
        console.error('Reply load failed', e);
      }
      this.isLoading = false;
    },
    t,
  },
  watch: {
    sortingMethod() {
      this.page = 1;
      this.comments = [];
      this.loadPage();
    },
    targetId: async function () {
      this.init();
    },
    commentType() {
      this.page = 1;
      this.comments = [];
      this.loadPage();
    },
  },
};

</script>
